import React from 'react';
import { Wallet } from 'lucide-react';

interface WalletInfoProps {
  address: string;
  nfdName?: string | null;
  balance: number;
  minBalance: number;
  rekeyTo?: string | null;
  credits: number;
  profile?: any;
  onClick: () => void;
}

const getAvatarUrl = (profile: any): string | null => {
  try {
    const avatarIpfs = profile?.nfd?.properties?.verified?.avatar;
    if (avatarIpfs) {
      // Convert IPFS URL to ipfs.io gateway URL
      return avatarIpfs.replace('ipfs://', 'https://ipfs.io/ipfs/');
    }
    return null;
  } catch {
    return null;
  }
};

export const WalletInfo: React.FC<WalletInfoProps> = ({
  address,
  nfdName,
  credits,
  profile,
  onClick
}) => {
  const avatarUrl = profile ? getAvatarUrl(profile) : null;

  return (
    <button
      onClick={onClick}
      className="flex items-center space-x-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
    >
      <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden bg-blue-600 dark:bg-blue-500">
        {avatarUrl ? (
          <img 
            src={avatarUrl}
            alt="Profile"
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback to wallet icon if image fails to load
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              target.parentElement?.classList.add('fallback-icon');
            }}
          />
        ) : (
          <Wallet size={20} className="text-white" />
        )}
      </div>
      <div className="hidden md:block text-left">
        <div className="text-sm font-medium text-gray-900 dark:text-white">
          {nfdName || `${address.slice(0, 4)}...${address.slice(-4)}`}
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          {credits} credits remaining
        </div>
      </div>
    </button>
  );
};